import React from 'react';

const HallAdd = () => {
    return (
        <div>
            
        </div>
    );
};

export default HallAdd;